import 'react-loading-skeleton/dist/skeleton.css';
import './BusinessAssessment.css';

import React, { useEffect, useState } from 'react';

import { Button } from '@/components/atoms';
import { FullscreenOverlay } from '@/components/molecules';
import { HELPERS } from '@/utils';
import { Icon } from '@iconify/react';
import PATH from '@/routes/path';
import ReactPixel from 'react-facebook-pixel';
import { SERVICE_AI_ASSESSMENT } from '@/services/aiService';
import { notify } from 'react-notify-toast';
import { sendCustomTag } from '@/utils/clarity-tags';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SuccessImage = '/images/success-subscribe.webp';






const QUIZ_STEPS = {
    NAME_INPUT: 0,
    WELCOME: 1,
    QUESTIONS_START: 2,
    REGISTRATION_FORM: 998,
    RESULTS: 999
};

const optionIcons = {
    'revenue_2x': 'twemoji:chart-increasing',
    'expand_new_market': 'twemoji:globe-showing-asia-australia',
    'launch_new_product': 'twemoji:party-popper',
    'build_solid_team': 'twemoji:people-holding-hands',

    'has_online_presence': 'fluent-emoji-flat:bell',
    'has_financial_record': 'fxemoji:memo',
    'has_team': 'twemoji:busts-in-silhouette',
    'has_regular_customers': 'twemoji:handshake',

    'low_sales': 'twemoji:chart-decreasing',
    'cash_flow_tight': 'twemoji:money-with-wings',
    'high_competition': 'twemoji:crossed-swords',
    'no_time': 'twemoji:hourglass-not-done',

    'digital_marketing': 'twemoji:megaphone',
    'financial_management': 'twemoji:money-bag',
    'team_management': 'twemoji:clipboard',
    'product_innovation': 'twemoji:light-bulb'
};

const ConversationalQuiz = ({ onComplete = null }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { loggedIn } = useSelector((state) => state.auth);

    const [currentStep, setCurrentStep] = useState(QUIZ_STEPS.NAME_INPUT);
    const [userName, setUserName] = useState('');
    const [answers, setAnswers] = useState({});
    const [hoveredOption, setHoveredOption] = useState(null);
    const [userInfo, setUserInfo] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [registrationError, setRegistrationError] = useState('');
    const [startTime, setStartTime] = useState(null);
    const [showEssay, setShowEssay] = useState({});
    const [essayText, setEssayText] = useState({});
    const [pageLoadTracked, setPageLoadTracked] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [formData, setFormData] = useState({
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
    });
    const [formErrors, setFormErrors] = useState({});

    const isGuest = !loggedIn;
    const [overlayEnabled, setOverlayEnabled] = useState(() => {
        return isGuest && sessionStorage.getItem('quizOverlayDisabled') !== '1';
    });

    const questionIndex = currentStep - QUIZ_STEPS.QUESTIONS_START;
    React.useEffect(() => {
        if (currentStep === QUIZ_STEPS.QUESTIONS_START && questionIndex === 0) {
            const question = questions[0];
            HELPERS.sendEventGA('guest_question_loaded', {
                page_source: 'Conversational Quiz',
                user_type: 'guest',
                question_index: 1,
                question_id: question.id,
                question_title: question.title,
                question_subtitle: question.subtitle,
                options_count: question.options.length,
                total_questions: questions.length
            });

            ReactPixel.track('ViewContent', {
                content_name: 'Question 1',
                content_category: 'assessment_question',
                question_id: question.id,
                question_order: 1,
            });

            sendCustomTag('guest_question', `viewed_${question.id}`);
        }
    }, [currentStep]);

    const questions = [
        {
            id: 'goal_target',
            greeting: `Oke ${userName || 'teman'},`,
            title: 'mau bisnismu jadi seperti apa?',
            subtitle: 'Pilih semua yang jadi impian kamu ya',
            options: [
                {
                    id: 'revenue_2x',
                    text: 'Omzet naik 2x lipat',
                    subtext: 'dalam setahun ini'
                },
                {
                    id: 'expand_new_market',
                    text: 'Buka cabang baru',
                    subtext: 'atau jangkau kota lain'
                },
                {
                    id: 'launch_new_product',
                    text: 'Launching produk baru',
                    subtext: 'yang laku di pasaran'
                },
                {
                    id: 'build_solid_team',
                    text: 'Punya tim solid',
                    subtext: 'yang bisa diandalkan'
                }
            ]
        },
        {
            id: 'current_situation',
            greeting: 'Mantap!',
            title: 'Sekarang, yang mana yang udah kamu punya?',
            subtitle: 'Jujur aja, biar rekomendasinya pas',
            options: [
                {
                    id: 'has_online_presence',
                    text: 'Aktif di sosmed',
                    subtext: '& punya toko online'
                },
                {
                    id: 'has_financial_record',
                    text: 'Keuangan tercatat',
                    subtext: 'rapi & teratur'
                },
                {
                    id: 'has_team',
                    text: 'Sudah ada tim',
                    subtext: 'atau karyawan'
                },
                {
                    id: 'has_regular_customers',
                    text: 'Pelanggan loyal',
                    subtext: 'yang repeat order'
                }
            ]
        },
        {
            id: 'main_challenges',
            greeting: 'Almost there!',
            title: 'Apa sih yang bikin kamu pusing?',
            subtitle: 'Yang jadi tantangan bisnis kamu sekarang',
            options: [
                {
                    id: 'low_sales',
                    text: 'Sepi orderan',
                    subtext: 'penjualan turun'
                },
                {
                    id: 'cash_flow_tight',
                    text: 'Modal terbatas',
                    subtext: 'cash flow seret'
                },
                {
                    id: 'high_competition',
                    text: 'Kompetitor banyak',
                    subtext: 'persaingan ketat'
                },
                {
                    id: 'no_time',
                    text: 'Waktu terbatas',
                    subtext: 'kewalahan sendirian'
                }
            ]
        },
        {
            id: 'skill_needs',
            greeting: 'Last question!',
            title: 'Skill apa yang pengen kamu kuasai?',
            subtitle: 'Biar bisnis makin maju',
            options: [
                {
                    id: 'digital_marketing',
                    text: 'Digital marketing',
                    subtext: 'jualan online efektif'
                },
                {
                    id: 'financial_management',
                    text: 'Kelola keuangan',
                    subtext: 'atur cash flow bisnis'
                },
                {
                    id: 'team_management',
                    text: 'Leadership',
                    subtext: 'pimpin & kelola tim'
                },
                {
                    id: 'product_innovation',
                    text: 'Inovasi produk',
                    subtext: 'bikin yang customer mau'
                }
            ]
        }
    ];

    useEffect(() => {
        if (!isGuest) {
            sessionStorage.removeItem('quizOverlayDisabled');
            setOverlayEnabled(false);
        } else {
            setOverlayEnabled(sessionStorage.getItem('quizOverlayDisabled') !== '1');
        }
        
        // Save UTM parameters when component loads
        HELPERS.saveUTMParameters();
        
        if (!pageLoadTracked && isGuest) {
            const utmParams = HELPERS.getUTMParameters();
            
            HELPERS.sendEventGA('assessment_page_load', {
                page_source: 'Conversational Quiz',
                page_path: window.location.pathname,
                user_status: 'guest',
                variant: 'conversational',
                ...utmParams // Include all UTM parameters
            });
            
            ReactPixel.track('ViewContent', {
                content_name: 'Conversational Assessment Page',
                content_category: 'personal_learning_assessment',
                content_type: 'conversational_quiz',
                ...utmParams // Include UTM for Facebook Pixel
            });
            
            sendCustomTag('assessment', 'page_loaded');
            
            HELPERS.sendEventGA('assessment_journey_started', {
                page_source: 'Conversational Quiz',
                journey_type: 'conversational',
                user_status: 'guest'
            });
            
            ReactPixel.track('Lead', {
                content_name: 'Assessment Journey Started',
                status: 'journey_started',
                journey_type: 'conversational'
            });
            
            sendCustomTag('assessment_journey', 'started');
            
            setPageLoadTracked(true);
        }
    }, [isGuest, pageLoadTracked]);

    const dismissOverlay = () => {
        setOverlayEnabled(false);
        try { sessionStorage.setItem('quizOverlayDisabled', '1'); } catch { }
        HELPERS.sendEventGA('guest_overlay_dismissed', {
            page_source: 'Conversational Quiz',
        });
    };

    const handleOptionToggle = (categoryId, optionId) => {
        const currentAnswers = answers[categoryId]?.selected || [];
        const newAnswers = currentAnswers.includes(optionId)
            ? currentAnswers.filter(id => id !== optionId)
            : [...currentAnswers, optionId];

        setAnswers({
            ...answers,
            [categoryId]: {
                ...answers[categoryId],
                selected: newAnswers,
                checkboxes: newAnswers
            }
        });
    };

    const isStepValid = () => {
        if (currentStep === QUIZ_STEPS.NAME_INPUT) return userName.trim().length > 0;
        if (currentStep === QUIZ_STEPS.WELCOME) return true;

        const questionIndex = currentStep - QUIZ_STEPS.QUESTIONS_START;
        if (questionIndex >= 0 && questionIndex < questions.length) {
            const question = questions[questionIndex];
            return answers[question.id]?.selected?.length > 0;
        }
        return false;
    };

    const getMotivationalMessage = () => {
        const messages = [
            "Nice! Lanjut yuk",
            "Keren! Tinggal dikit lagi",
            "Super! Satu lagi nih",
            "Perfect! Siap lihat hasil?"
        ];
        const questionIndex = currentStep - QUIZ_STEPS.QUESTIONS_START;
        return messages[questionIndex] || "Lanjut!";
    };

    const handleNext = () => {
        const totalQuestions = questions.length;
        const isLastQuestion = currentStep === QUIZ_STEPS.QUESTIONS_START + totalQuestions - 1;
        
        // Track when user completes a question (1, 2, 3, or 4)
        const questionIndex = currentStep - QUIZ_STEPS.QUESTIONS_START;
        if (questionIndex >= 0 && questionIndex < questions.length) {
            const questionNumber = questionIndex + 1;
            
            HELPERS.sendEventGA('question_completed', {
                page_source: 'Conversational Quiz',
                user_type: 'guest',
                question_number: questionNumber,
                completed: true
            });
            
            ReactPixel.track('Lead', {
                content_name: `Question ${questionNumber} Completed`,
                status: 'completed',
                question_number: questionNumber
            });
            
            sendCustomTag('quiz_progress', `question_${questionNumber}_completed`);
        }
        
        if (currentStep === QUIZ_STEPS.WELCOME) {
            // Track intro completed (Step 7 in funnel)
            HELPERS.sendEventGA('guest_intro_completed', {
                page_source: 'Conversational Quiz',
                user_type: 'guest',
                progression: 'to_quiz'
            });

            ReactPixel.track('Lead', {
                content_name: 'Guest Introduction Complete',
                status: 'ready_for_quiz'
            });

            sendCustomTag('guest_intro', 'completed');
            
            HELPERS.sendEventGA('assessment_started', {
                page_source: 'Conversational Quiz',
                assessment_step: 'initial',
                user_status: 'guest',
                variant: 'conversational'
            });

            ReactPixel.track('Lead', {
                content_name: 'Conversational Assessment Started',
                status: 'assessment_started',
            });
            
            sendCustomTag('assessment', 'started');
            
            HELPERS.sendEventGA('guest_static_questions_loaded', {
                page_source: 'Conversational Quiz',
                user_type: 'guest',
                question_type: 'static',
                categories_count: totalQuestions,
            });

            ReactPixel.track('ViewContent', {
                content_name: 'Guest Static Assessment Questions',
                content_category: 'assessment',
                content_type: 'static_questions',
            });

            sendCustomTag('guest_assessment', 'static_questions_loaded');
        }

        if (isLastQuestion) {
            const timeSpent = startTime ? Math.floor((Date.now() - startTime) / 1000) : 0;
            
            const utmParams = HELPERS.getUTMParameters();
            
            // Track that all 4 questions were completed
            HELPERS.sendEventGA('all_questions_completed', {
                page_source: 'Conversational Quiz',
                user_type: 'guest',
                total_questions_completed: totalQuestions,
                all_completed: true,
                time_spent_seconds: timeSpent,
                ...utmParams
            });

            ReactPixel.track('Lead', {
                content_name: 'All Questions Completed',
                status: 'ready_for_registration',
                questions_completed: totalQuestions
            });

            sendCustomTag('quiz_complete', 'all_4_questions_done');
            
            if (!loggedIn) {
                setCurrentStep(QUIZ_STEPS.REGISTRATION_FORM);
            } else {
                handleSubmitAssessment();
            }
        } else {
            setCurrentStep(currentStep + 1);
        }
    };

    const handleBack = () => {
        if (currentStep > QUIZ_STEPS.NAME_INPUT) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleStartQuiz = () => {
        setStartTime(Date.now());
        setUserInfo({ name: userName.trim() });

        HELPERS.sendEventGA('guest_name_submitted', {
            page_source: 'Conversational Quiz',
            user_type: 'guest',
            name_length: userName.trim().length
        });

        ReactPixel.track('Lead', {
            content_name: 'Guest Name Collection',
            status: 'name_submitted'
        });

        sendCustomTag('guest_intro', 'name_submitted');

        setCurrentStep(QUIZ_STEPS.WELCOME);
    };

    const handleRegistrationSubmit = async (registrationData) => {
        setIsSubmitting(true);

        try {
            const formattedAnswers = {};
            Object.keys(answers).forEach(categoryId => {
                formattedAnswers[categoryId] = {
                    checkboxes: answers[categoryId].selected || [],
                    essay: answers[categoryId].essay || essayText[categoryId] || ''
                };
            });

            const response = await SERVICE_AI_ASSESSMENT.submitAssessmentWithRegistration(
                registrationData,
                formattedAnswers
            );

            if (response.success) {
                const responseData = response.data || response.payload;

                const utmParams = HELPERS.getUTMParameters();
                
                HELPERS.sendEventGA('assessment_with_registration_success', {
                    page_source: 'Conversational Quiz',
                    user_type: responseData.user_type || 'guest',
                    activation_required: responseData.activation_required,
                    variant: 'conversational',
                    ...utmParams,
                    conversion_source: utmParams.utm_source || 'organic'
                });

                ReactPixel.track('CompleteRegistration', {
                    content_name: 'Assessment Auto Registration',
                    method: 'conversational_flow',
                    ...utmParams
                });
                
                sendCustomTag('assessment_registration', 'success');

                if (responseData.activation_required) {
                    notify.show('Quiz berhasil! Cek email untuk aktivasi akun dan lihat hasil.', 'success', 8000);
                    
                    HELPERS.sendEventGA('guest_activation_required', {
                        page_source: 'Conversational Quiz',
                        redirect_to: 'login',
                    });
                    
                    setTimeout(() => {
                        history.push(`${PATH.AUTH_LOGIN}?redirect=/personal-learning-program`);
                    }, 2000);
                } else {
                    setCurrentStep(QUIZ_STEPS.RESULTS);
                    if (onComplete) {
                        onComplete(responseData.assessment || responseData);
                    }
                }
            } else {
                const errorData = response.error || response.payload?.error;
                let errorMessage = 'Gagal menyimpan data. Silakan coba lagi.';

                if (errorData?.message) {
                    if (errorData.message.includes('sudah digunakan')) {
                        errorMessage = 'Email atau nomor handphone sudah digunakan. Silakan gunakan data lain atau login.';
                    } else {
                        errorMessage = errorData.message;
                    }
                }
                setRegistrationError(errorMessage);
            }
        } catch (error) {
            setRegistrationError('Gagal menyimpan data. Silakan coba lagi.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubmitAssessment = async () => {
        // For logged in users - similar to BusinessAssessment.jsx
        setIsSubmitting(true);

        try {
            const timeSpent = startTime ? Math.floor((Date.now() - startTime) / 1000) : 0;
            const completionRate = Object.keys(answers).length / questions.length;

            // Generate assessment ID for logged in users
            const assessmentId = `logged-in-${Date.now()}`;

            // Track assessment completion for logged in users
            HELPERS.sendEventGA('assessment_completed', {
                page_source: 'Conversational Quiz',
                assessment_id: assessmentId,
                user_status: 'logged_in',
                variant: 'conversational',
                completion_time: timeSpent,
                completion_rate: completionRate,
                categories_answered: Object.keys(answers).length,
            });

            ReactPixel.track('CompleteRegistration', {
                content_name: 'Conversational Assessment Completed',
                status: 'assessment_completed',
                user_type: 'logged_in',
            });

            sendCustomTag('assessment', 'completed_logged_in');

            // Format answers for submission
            const formattedAnswers = {};
            Object.keys(answers).forEach(categoryId => {
                formattedAnswers[categoryId] = {
                    checkboxes: answers[categoryId].selected || [],
                    essay: answers[categoryId].essay || essayText[categoryId] || ''
                };
            });

            const metadata = {
                timeSpent,
                completionRate,
                variant: 'conversational',
                deviceInfo: {
                    userAgent: navigator.userAgent,
                    platform: navigator.platform,
                },
            };

            const response = await SERVICE_AI_ASSESSMENT.submitAssessmentAnswers(assessmentId, formattedAnswers, metadata);
            
            const responseData = response.data || response.payload;

            if (response.success && responseData) {
                const assessmentData = responseData.assessment || responseData;

                if (!assessmentData.recommendations || !Array.isArray(assessmentData.recommendations)) {
                    throw new Error('Invalid recommendations data received from server');
                }

                const submissionData = {
                    recommendations: assessmentData.recommendations || [],
                    analysis: assessmentData.analysis || {},
                    bundle: assessmentData.bundle || {},
                    bundle_pricing: assessmentData.bundle_pricing || {},
                    nextSteps: assessmentData.nextSteps || [],
                    personal_learning_path: assessmentData.personal_learning_path || null,
                    mentoring: assessmentData.mentoring || null,
                };

                setCurrentStep(QUIZ_STEPS.RESULTS);

                if (onComplete) {
                    onComplete(submissionData);
                }

                HELPERS.sendEventGA('assessment_recommendations_generated', {
                    page_source: 'Conversational Quiz',
                    assessment_id: assessmentId,
                    recommendations_count: assessmentData.recommendations?.length || 0,
                    mentoring_available: assessmentData.mentoring?.available || false,
                    personal_learning_path_available: !!assessmentData.personal_learning_path,
                    total_value: assessmentData.personal_learning_path?.pricing?.remaining_amount || 0,
                });

                ReactPixel.track('Purchase', {
                    content_name: 'Assessment Recommendations Ready',
                    content_category: 'assessment',
                    value: assessmentData.personal_learning_path?.pricing?.remaining_amount || 0,
                    currency: 'IDR',
                });

            } else {
                throw new Error('Failed to get recommendations');
            }
        } catch (error) {
            console.error('Assessment submission error:', error);
            notify.show('Gagal mengirim jawaban. Silakan coba lagi.', 'error');
            
            HELPERS.sendEventGA('assessment_submission_error', {
                page_source: 'Conversational Quiz',
                user_status: 'logged_in',
                error_message: error.message,
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.email.trim()) {
            newErrors.email = 'Email wajib diisi';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Format email tidak valid';
        }

        if (!formData.phone.trim()) {
            newErrors.phone = 'Nomor handphone wajib diisi';
        } else if (!/^[0-9]{8,15}$/.test(formData.phone.replace(/[^0-9]/g, ''))) {
            newErrors.phone = 'Nomor handphone tidak valid';
        }

        if (!formData.password.trim()) {
            newErrors.password = 'Password wajib diisi';
        } else if (formData.password.length < 8) {
            newErrors.password = 'Password minimal 8 karakter';
        }

        if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Konfirmasi password tidak cocok';
        }

        setFormErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const utmParams = HELPERS.getUTMParameters();
            
            HELPERS.sendEventGA('guest_registration_submitted', {
                page_source: 'Conversational Quiz',
                user_type: 'guest',
                form_step: 'final_submission',
                has_phone: !!formData.phone.trim(),
                variant: 'conversational',
                ...utmParams
            });

            ReactPixel.track('CompleteRegistration', {
                content_name: 'Guest Registration Form',
                status: 'form_submitted',
                method: 'conversational_quiz',
                ...utmParams
            });

            sendCustomTag('guest_registration', 'form_submitted');
            
            const registrationData = {
                ...userInfo,
                email: formData.email.trim(),
                phone: formData.phone.replace(/[^0-9]/g, '').replace(/^0/, ''),
                password: formData.password,
            };
            handleRegistrationSubmit(registrationData);
        }
    };

    const handleFormChange = (field) => (e) => {
        setFormData({ ...formData, [field]: e.target.value });
        if (formErrors[field]) {
            setFormErrors({ ...formErrors, [field]: '' });
        }
        if (registrationError) {
            setRegistrationError('');
        }
    };

    const renderRegistrationForm = () => {

        return (
            <div className="p-8 max-w-lg mx-auto">
                <div className="text-center mb-8">
                    <h2 className="text-2xl md:text-3xl font-bold text-purple-600 mb-4">
                        Hampir Selesai!
                    </h2>
                    <p className="text-gray-600 mb-2">
                        Quiz kamu sudah selesai, {userName}!
                    </p>
                    <p className="text-sm text-gray-500">
                        <span className="font-medium text-purple-600">Hasil akan muncul di akun kamu.</span><br />
                        Buat akun dulu untuk lihat rekomendasi personal.
                    </p>
                </div>

                {registrationError && (
                    <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                        <p className="text-red-700 text-sm">{registrationError}</p>
                    </div>
                )}

                <form onSubmit={handleFormSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Email *
                        </label>
                        <input
                            type="email"
                            value={formData.email}
                            onChange={handleFormChange('email')}
                            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none ${formErrors.email ? 'border-red-500' : 'border-gray-300'}`}
                            placeholder="email@contoh.com"
                        />
                        {formErrors.email && <p className="text-red-500 text-sm mt-1">{formErrors.email}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Nomor Handphone *
                        </label>
                        <div className="flex">
                            <span className="inline-flex items-center px-3 bg-gray-50 border border-r-0 border-gray-300 rounded-l-lg text-gray-500">
                                +62
                            </span>
                            <input
                                type="tel"
                                value={formData.phone}
                                onChange={handleFormChange('phone')}
                                className={`w-full px-4 py-3 border rounded-r-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none ${formErrors.phone ? 'border-red-500' : 'border-gray-300'}`}
                                placeholder="81234567890"
                            />
                        </div>
                        {formErrors.phone && <p className="text-red-500 text-sm mt-1">{formErrors.phone}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Password *
                        </label>
                        <div className="relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                value={formData.password}
                                onChange={handleFormChange('password')}
                                className={`w-full px-4 py-3 pr-12 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none ${formErrors.password ? 'border-red-500' : 'border-gray-300'}`}
                                placeholder="Minimal 8 karakter"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                            >
                                <Icon 
                                    icon={showPassword ? "material-symbols:visibility-off-outline" : "material-symbols:visibility-outline"} 
                                    className="w-5 h-5" 
                                />
                            </button>
                        </div>
                        {formErrors.password && <p className="text-red-500 text-sm mt-1">{formErrors.password}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Konfirmasi Password *
                        </label>
                        <div className="relative">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                value={formData.confirmPassword}
                                onChange={handleFormChange('confirmPassword')}
                                className={`w-full px-4 py-3 pr-12 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none ${formErrors.confirmPassword ? 'border-red-500' : 'border-gray-300'}`}
                                placeholder="Ulangi password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                            >
                                <Icon 
                                    icon={showConfirmPassword ? "material-symbols:visibility-off-outline" : "material-symbols:visibility-outline"} 
                                    className="w-5 h-5" 
                                />
                            </button>
                        </div>
                        {formErrors.confirmPassword && <p className="text-red-500 text-sm mt-1">{formErrors.confirmPassword}</p>}
                    </div>

                    <div className="flex gap-3 pt-4">
                        <Button
                            onClick={() => setCurrentStep(QUIZ_STEPS.QUESTIONS_START + questions.length - 1)}
                            variant={Button.VARIANTS.GRAY_OUTLINE}
                            size={Button.SIZES.MEDIUM}
                            type="button"
                            disabled={isSubmitting}
                        >
                            Kembali
                        </Button>
                        <Button
                            type="submit"
                            variant={Button.VARIANTS.SECONDARY}
                            size={Button.SIZES.MEDIUM}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Menyiapkan rekomendasi...' : 'Lihat Rekomendasi Bisnis!'}
                        </Button>
                    </div>
                </form>
            </div>
        );
    };

    const renderStep = () => {
        // Step 0: Name Input
        if (currentStep === QUIZ_STEPS.NAME_INPUT) {
            return (
                <div className="text-center p-8 flex flex-col items-center justify-center min-h-[500px]">
                    <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                        Hai! Salam kenal
                    </h1>

                    <p className="text-md text-gray-600 mb-2 max-w-md">
                        Kami mau bantu kamu nemuin program belajar yang
                        <span className="text-purple-600 font-semibold"> cocok banget</span> buat bisnis kamu
                    </p>

                    <p className="text-sm text-gray-500 mb-6">
                        Pertama, boleh kenalan dulu?
                    </p>

                    <div className="w-full max-w-md mb-8">
                        <input
                            type="text"
                            placeholder="Nama kamu siapa?"
                            className="w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none transition-colors"
                            maxLength={30}
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' && userName.trim()) {
                                    handleStartQuiz();
                                }
                            }}
                        />
                        <p className="text-xs text-gray-500 mt-2 text-center">
                            Nama depan aja gapapa kok
                        </p>
                    </div>

                    {/* Social Proof */}
                    <div className="flex items-center gap-3 mb-8">
                        <div className="flex -space-x-2">
                            <div className="w-8 h-8 bg-purple-200 rounded-full border-2 border-white flex items-center justify-center">
                                <span className="text-xs font-semibold text-purple-700">A</span>
                            </div>
                            <div className="w-8 h-8 bg-blue-200 rounded-full border-2 border-white flex items-center justify-center">
                                <span className="text-xs font-semibold text-blue-700">R</span>
                            </div>
                            <div className="w-8 h-8 bg-green-200 rounded-full border-2 border-white flex items-center justify-center">
                                <span className="text-xs font-semibold text-green-700">S</span>
                            </div>
                        </div>
                        <p className="text-sm text-gray-600">
                            <strong>327 owner bisnis</strong> sudah ikut hari ini
                        </p>
                    </div>

                    <Button
                        onClick={handleStartQuiz}
                        variant={Button.VARIANTS.SECONDARY}
                        size={Button.SIZES.MEDIUM}
                        disabled={!userName.trim()}
                    >
                        Lanjut
                    </Button>
                </div>
            );
        }

        // Step 1: Welcome Back
        if (currentStep === QUIZ_STEPS.WELCOME) {
            return (
                <div className="text-center p-8 flex flex-col items-center justify-center min-h-[500px]">
                    <img src={SuccessImage} alt="Mari Mulai Assessment" className="w-48 md:w-64 mb-8" />

                    <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                        Sip, senang kenalan sama kamu {userName}!
                    </h1>

                    <p className="text-md text-gray-600 mb-2">
                        Sekarang kami akan tanya <span className="font-semibold">4 pertanyaan singkat</span> tentang bisnis kamu
                    </p>

                    <p className="text-sm text-gray-500 mb-8">
                        Santai aja, gak ada jawaban salah kok!
                    </p>

                    {/* What to expect */}
                    <div className="bg-purple-50 rounded-xl p-4 mb-8 w-full max-w-md">
                        <div className="space-y-3">
                            <div className="flex items-center gap-3">
                                <Icon icon="material-symbols:schedule" className="w-5 h-5 text-purple-600" />
                                <span className="text-sm text-gray-700">Cuma 2 menit</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <Icon icon="material-symbols:check-circle-outline" className="w-5 h-5 text-purple-600" />
                                <span className="text-sm text-gray-700">Dapat rekomendasi personal</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <Icon icon="material-symbols:groups-outline" className="w-5 h-5 text-purple-600" />
                                <span className="text-sm text-gray-700">Join komunitas eksklusif</span>
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-3">
                        <Button
                            onClick={handleBack}
                            variant={Button.VARIANTS.GRAY_OUTLINE}
                            size={Button.SIZES.MEDIUM}
                        >
                            Kembali
                        </Button>
                        <Button
                            onClick={handleNext}
                            variant={Button.VARIANTS.SECONDARY}
                            size={Button.SIZES.MEDIUM}
                            className="flex items-center gap-2"
                        >
                            Oke, mulai!
                            <Icon icon="material-symbols:arrow-forward" className="w-4 h-4" />
                        </Button>
                    </div>
                </div>
            );
        }

        // Registration Form
        if (currentStep === QUIZ_STEPS.REGISTRATION_FORM) {
            return renderRegistrationForm();
        }

        // Results
        if (currentStep === QUIZ_STEPS.RESULTS) {
            return (
                <div className="text-center p-8">
                    <h2 className="text-2xl font-bold text-purple-600 mb-4">
                        Selamat! Quiz Selesai
                    </h2>
                    <p className="text-gray-600">
                        Rekomendasi personal kamu sudah siap!
                    </p>
                </div>
            );
        }

        // Question Steps
        const questionIndex = currentStep - QUIZ_STEPS.QUESTIONS_START;
        if (questionIndex >= 0 && questionIndex < questions.length) {
            const question = questions[questionIndex];
            const selectedAnswers = answers[question.id]?.selected || [];

            return (
                <div className="p-6 min-h-[500px] flex flex-col">
                    {/* Progress */}
                    <div className="mb-6">
                        <div className="flex items-center justify-between text-sm text-gray-500 mb-2">
                            <span>Pertanyaan {questionIndex + 1} dari 4</span>
                            <span className="text-purple-600 font-medium">
                                {4 - questionIndex - 1 === 0 ? 'Last one!' : `${4 - questionIndex - 1} lagi`}
                            </span>
                        </div>
                        <div className="w-full bg-gray-200 h-2 rounded-full overflow-hidden">
                            <div
                                className="bg-gradient-to-r from-purple-500 to-purple-600 h-full rounded-full transition-all duration-500"
                                style={{ width: `${((questionIndex + 1) / 4) * 100}%` }}
                            />
                        </div>
                    </div>

                    {/* Question Content */}
                    <div className="flex-grow">

                        <p className="text-purple-600 font-medium mb-2">{question.greeting}</p>
                        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                            {question.title}
                        </h2>
                        <p className="text-sm text-gray-500 mb-6">{question.subtitle}</p>

                        {/* Options */}
                        <div className="grid grid-cols-2 gap-3">
                            {question.options.map((option) => {
                                const iconName = optionIcons[option.id];
                                const isSelected = selectedAnswers.includes(option.id);

                                return (
                                    <button
                                        key={option.id}
                                        onClick={() => handleOptionToggle(question.id, option.id)}
                                        onMouseEnter={() => setHoveredOption(option.id)}
                                        onMouseLeave={() => setHoveredOption(null)}
                                        className={`p-4 rounded-xl border-2 text-left transition-all relative overflow-hidden ${isSelected
                                            ? 'border-purple-500 bg-purple-50 shadow-md'
                                            : hoveredOption === option.id
                                                ? 'border-purple-300 bg-gray-50'
                                                : 'border-gray-200 bg-white'
                                            }`}
                                    >
                                        {/* Icon in top right */}
                                        {iconName && (
                                            <div className="absolute top-2 right-2 opacity-80">
                                                <Icon
                                                    icon={iconName}
                                                    className="w-10 h-10 md:w-12 md:h-12"
                                                />
                                            </div>
                                        )}

                                        {/* Text content with padding to avoid icon */}
                                        <div className={`${iconName ? 'pr-14' : ''}`}>
                                            <div className="font-medium text-gray-900 text-sm mb-1">
                                                {option.text}
                                            </div>
                                            <div className="text-xs text-gray-500">
                                                {option.subtext}
                                            </div>
                                        </div>
                                    </button>
                                );
                            })}
                        </div>

                        {/* Essay option - Lainnya */}
                        <div className="mt-4">
                            <label className="flex items-start cursor-pointer group">
                                <input
                                    type="checkbox"
                                    className="h-5 w-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500 mt-0.5"
                                    checked={showEssay[question.id] || false}
                                    onChange={() => {
                                        setShowEssay({
                                            ...showEssay,
                                            [question.id]: !showEssay[question.id]
                                        });
                                        if (!showEssay[question.id]) {
                                            // Clear essay text when unchecking
                                            setEssayText({
                                                ...essayText,
                                                [question.id]: ''
                                            });
                                        }
                                    }}
                                />
                                <span className="ml-3 text-gray-700 group-hover:text-purple-600 transition-colors">
                                    Ada hal lain? Ceritakan di sini...
                                </span>
                            </label>

                            {/* Essay textarea */}
                            {showEssay[question.id] && (
                                <div className="mt-3 animate-fadeIn">
                                    <textarea
                                        className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 resize-none"
                                        rows="3"
                                        placeholder="Tulis jawaban kamu di sini..."
                                        value={essayText[question.id] || ''}
                                        onChange={(e) => {
                                            const text = e.target.value;
                                            setEssayText({
                                                ...essayText,
                                                [question.id]: text
                                            });
                                            // Update answers with essay
                                            setAnswers({
                                                ...answers,
                                                [question.id]: {
                                                    ...answers[question.id],
                                                    essay: text
                                                }
                                            });
                                            
                                            // Track essay interaction
                                            if (text.length > 0 && text.length % 10 === 0) { // Track every 10 chars
                                                HELPERS.sendEventGA('guest_question_essay_progress', {
                                                    page_source: 'Conversational Quiz',
                                                    user_type: 'guest',
                                                    question_id: question.id,
                                                    essay_length: text.length,
                                                    has_content: text.trim().length > 0,
                                                });
                                            }
                                        }}
                                        onBlur={(e) => {
                                            // Track when user finishes typing essay
                                            if (e.target.value.trim()) {
                                                HELPERS.sendEventGA('guest_question_essay_completed', {
                                                    page_source: 'Conversational Quiz',
                                                    user_type: 'guest',
                                                    question_id: question.id,
                                                    essay_length: e.target.value.length,
                                                });
                                                
                                                sendCustomTag('guest_essay', `completed_${question.id}`);
                                            }
                                        }}
                                        maxLength={150}
                                    />
                                    <p className={`text-xs mt-1 text-right ${(essayText[question.id] || '').length > 150 ? 'text-red-500' : 'text-gray-500'
                                        }`}>
                                        {(essayText[question.id] || '').length}/150 karakter
                                    </p>
                                </div>
                            )}
                        </div>

                        {/* Motivational message */}
                        {selectedAnswers.length > 0 && (
                            <p className="text-center text-sm text-purple-600 mt-4">
                                {getMotivationalMessage()}
                            </p>
                        )}
                    </div>

                    {/* Navigation */}
                    <div className="flex gap-3 mt-6">
                        <Button
                            onClick={handleBack}
                            variant={Button.VARIANTS.GRAY_OUTLINE}
                            size={Button.SIZES.MEDIUM}
                            className="flex-1"
                        >
                            Kembali
                        </Button>
                        <Button
                            onClick={handleNext}
                            disabled={!isStepValid()}
                            variant={Button.VARIANTS.SECONDARY}
                            size={Button.SIZES.MEDIUM}
                            className="flex-1 flex items-center justify-center gap-2"
                        >
                            {questionIndex === 3 ? 'Lihat Hasil' : 'Lanjut'}
                            <Icon icon="material-symbols:arrow-forward" className="w-4 h-4" />
                        </Button>
                    </div>
                </div>
            );
        }

        return null;
    };

    const content = (
        <div className="bg-gray-50 min-h-screen flex items-center justify-center p-4">
            <div className="w-full max-w-3xl">
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                    {renderStep()}
                </div>
            </div>
        </div>
    );

    // Wrap with FullscreenOverlay for guest users
    if (isGuest && overlayEnabled) {
        return (
            <FullscreenOverlay
                lockScroll
                closeOnBackdropClick={false}
                closeOnEsc
                backdropClassName="bg-white"
                zIndex={9999}
                aria-label="Conversational Quiz Guest Overlay"
                onClose={dismissOverlay}
                showClose={currentStep === QUIZ_STEPS.NAME_INPUT}
            >
                <div className="w-full h-full flex flex-col">
                    <div className="flex-1 overflow-y-auto overflow-x-hidden">
                        <div className="min-h-full flex items-center justify-center p-4">
                            <div className="w-full max-w-3xl mx-auto">
                                <div className="bg-white rounded-xl">
                                    {renderStep()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FullscreenOverlay>
        );
    }

    return content;
};

export default ConversationalQuiz;